var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterX = function SvgTwitterX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.929 3h3.147L15.2 10.858l8.088 10.693h-6.333l-4.96-6.485L6.32 21.55H3.17l7.355-8.405L2.765 3H9.26l4.484 5.928L18.93 3Zm-1.105 16.668h1.744L8.312 4.785H6.44l11.383 14.883Z"
  })));
};
export { SvgTwitterX as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjUgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE4LjkyOSAzaDMuMTQ3TDE1LjIgMTAuODU4bDguMDg4IDEwLjY5M2gtNi4zMzNsLTQuOTYtNi40ODVMNi4zMiAyMS41NUgzLjE3bDcuMzU1LTguNDA1TDIuNzY1IDNIOS4yNmw0LjQ4NCA1LjkyOEwxOC45MyAzWm0tMS4xMDUgMTYuNjY4aDEuNzQ0TDguMzEyIDQuNzg1SDYuNDRsMTEuMzgzIDE0Ljg4M1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";